<template>
    <div class="totals-wrap">
        <div>
            <div class="blue-circle">
                <i class="fa fa-pencil"></i>
            </div>
            <div class="text">
                <div class="count">{{data.tweets}}</div>
                <div class="name">Tweets</div>
            </div>
        </div>
        <div>
            <div class="blue-circle">
                <i class="fa fa-retweet"></i>
            </div>
            <div class="text">
                <div class="count">{{data.retweets}}</div>
                <div class="name">Retweets</div>
            </div>
        </div>
        <div>
            <div class="blue-circle">
                <i class="fa fa-user"></i>
            </div>
            <div class="text">
                <div class="count">{{data.accounts}}</div>
                <div class="name">Accounts</div>
            </div>
        </div>

        <div>
            <div class="blue-circle">
                <i class="fa fa-heart"></i>
            </div>
            <div class="text">
                <div class="count">{{data.likes}}</div>
                <div class="name">Likes</div>
            </div>
        </div>
        <div>
            <div class="blue-circle">
                <i class="fa fa-comment"></i>
            </div>
            <div class="text">
                <div class="count">{{data.replies}}</div>
                <div class="name">Replies</div>
            </div>
        </div>
        <div>
            <div class="blue-circle">
                <i class="fa fa-eye"></i>
            </div>
            <div class="text">
                <div class="count">{{data.exposure | formatBigNumbers(1)}}</div>
                <div class="name">Exposure</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Total',
        props: ['data']
    }
</script>

<style scoped lang="scss">
    .totals-wrap {
        margin:40px 0px;
        display: flex;
        flex-wrap: wrap;
        font-size: 15px;

        &.loading-animation {
            -webkit-filter: grayscale(100%);
            filter: grayscale(100%);
            pointer-events: none;
            animation-name: blink;
            animation-duration: 2s;
            animation-timing-function: ease-out;
            animation-iteration-count: infinite;

           .count {
                background-color: #e0e0e0;
                color: #e0e0e0;
                border-color: #e0e0e0;
            }
        }

        &.locked {
            -webkit-filter: grayscale(100%);
            filter: grayscale(100%);
            opacity: 0.4;
            pointer-events: none;

            .count {
                filter: blur(5px);
            }
        }
        >div {
            flex-basis: 14%;
            min-width: 130px;
            margin: 8px;
        }
        .blue-circle {
            float: left;
            background-color: #0b93d5;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            color: white;
            text-align: center;
            i {
                font-size: 25px;
                line-height: 48px;
                padding-top: 1px;
            }
        }
        .text {
            float: left;
            .count {
                margin-left: 8px;
                font-size: 26px;
                font-weight: bold;
                min-height: 37px;
            }
            .name {
                padding-left: 8px;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Total.vue